/* ============================================================
   Golden Pear LE — Landing Page interactions

   Server-side rendering via Liquid handles the cans-found
   counter for SEO + no-flash. This file handles:
     - Pack tier selection (radio button behavior)
     - Quantity stepper increment/decrement (with min/max clamp)
     - Total price recalculation when pack or qty changes
     - Add-to-cart (main + sticky mobile) via /cart/add.js + openCartDrawer
     - Sticky mobile ATC visibility via IntersectionObserver
     - Funnel analytics events (page view, pack select, ATC, CTAs)
   ============================================================ */
(function () {
  'use strict';

  function init() {
    // Scope to the shop section's wrapper — every section has a .ks-gp-lp wrapper,
    // we want the one that actually contains the buy box.
    var root = document.querySelector('.ks-gp-lp[data-qty-limit]')
            || document.querySelector('.ks-gp-section-shop .ks-gp-lp')
            || document.querySelector('#ks-gp-shop').closest('.ks-gp-lp');
    if (!root) return;

    var packs = root.querySelectorAll('.pack[data-variant-id]');
    var qtyInput = root.querySelector('.qty-stepper input');
    var qtyDec = root.querySelector('.qty-stepper button[data-action="dec"]');
    var qtyInc = root.querySelector('.qty-stepper button[data-action="inc"]');
    var totalEl = root.querySelector('.total-amount');
    var atcBtn = root.querySelector('.add-to-cart');
    var stickyBar = root.querySelector('.sticky-atc');
    var stickyPack = root.querySelector('[data-sticky-pack-name]');
    var stickyTotal = root.querySelector('[data-sticky-total]');
    var stickyBtn = root.querySelector('[data-sticky-atc]');

    var qtyLimit = parseInt(root.dataset.qtyLimit || '6', 10);
    if (isNaN(qtyLimit) || qtyLimit < 1) qtyLimit = 6;

    function getSelectedPack() {
      return root.querySelector('.pack.selected');
    }

    function recalc() {
      var pack = getSelectedPack();
      if (!pack) return;
      var price = parseFloat(pack.dataset.priceCents) / 100;
      var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
      var total = '$' + (price * qty).toFixed(2);
      if (totalEl) totalEl.textContent = total;
      if (stickyTotal) stickyTotal.textContent = total;
      if (stickyPack) stickyPack.textContent = pack.dataset.packName || pack.querySelector('.pack-name') && pack.querySelector('.pack-name').textContent.trim() || '';
    }

    // Pack tier selection
    packs.forEach(function (pack) {
      function select() {
        packs.forEach(function (p) {
          p.classList.remove('selected');
          p.setAttribute('aria-checked', 'false');
        });
        pack.classList.add('selected');
        pack.setAttribute('aria-checked', 'true');
        emit('gp_pack_select', {
          variant_id: pack.dataset.variantId,
          pack_name: pack.dataset.packName || ''
        });
        recalc();
      }
      pack.addEventListener('click', select);
      pack.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          select();
        }
      });
    });

    // Quantity stepper
    if (qtyDec) {
      qtyDec.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, v - 1);
        recalc();
      });
    }
    if (qtyInc) {
      qtyInc.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.min(qtyLimit, v + 1);
        recalc();
      });
    }

    // ATC submission — factored out so both main + sticky buttons can call it.
    // Pattern matches cw-sweeps-products.liquid (AJAX + window.openCartDrawer).
    function submitAdd(triggerBtn) {
      var pack = getSelectedPack();
      if (!pack) return;
      var variantId = pack.dataset.variantId;
      var qty = parseInt(qtyInput && qtyInput.value, 10) || 1;
      if (!variantId) return;
      if (triggerBtn && triggerBtn.disabled) return;

      var btnSpan = triggerBtn && (triggerBtn.querySelector('span') || triggerBtn);
      var originalText = btnSpan && btnSpan.textContent;

      emit('gp_atc_click', { variant_id: variantId, quantity: qty, source: triggerBtn === stickyBtn ? 'sticky' : 'main' });

      // Pending state on whichever button was clicked + the other one too
      [atcBtn, stickyBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = true;
        b.setAttribute('aria-busy', 'true');
        var s = b.querySelector('span') || b;
        s.dataset.gpOriginal = s.textContent;
        s.textContent = 'Adding...';
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty }] })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('ATC failed: ' + res.status);
          return res.json();
        })
        .then(function () {
          emit('gp_atc_success', { variant_id: variantId, quantity: qty });
          restoreButtons();
          if (window.jQuery) {
            window.jQuery.getJSON('/cart.js', function (cart) {
              window.jQuery('.cart-count').text(cart.item_count);
            });
          }
          if (typeof window.openCartDrawer === 'function') {
            window.openCartDrawer();
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function (err) {
          emit('gp_atc_error', { variant_id: variantId, reason: String(err && err.message || err) });
          restoreButtons();
          console.error('[Golden Pear LP] Add-to-cart error:', err);
          alert('Could not add to cart. Please try again.');
        });
    }

    function restoreButtons() {
      [atcBtn, stickyBtn].forEach(function (b) {
        if (!b) return;
        b.disabled = false;
        b.removeAttribute('aria-busy');
        var s = b.querySelector('span') || b;
        if (s.dataset.gpOriginal) {
          s.textContent = s.dataset.gpOriginal;
          delete s.dataset.gpOriginal;
        }
      });
    }

    if (atcBtn) {
      atcBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        submitAdd(atcBtn);
      });
    }
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        submitAdd(stickyBtn);
      });
    }

    // Sticky bar visibility — show after user scrolls past the main buy-box total row.
    // Uses IntersectionObserver for performance (no scroll handlers).
    if (stickyBar && 'IntersectionObserver' in window) {
      var sentinel = root.querySelector('.total-row') || root.querySelector('.add-to-cart');
      if (sentinel) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            // Show sticky bar when the main ATC area is NOT in view
            // AND user has scrolled at least a screen past the top of the page
            var pastFold = window.scrollY > window.innerHeight * 0.5;
            if (!entry.isIntersecting && pastFold) {
              stickyBar.classList.add('visible');
              stickyBar.setAttribute('aria-hidden', 'false');
            } else {
              stickyBar.classList.remove('visible');
              stickyBar.setAttribute('aria-hidden', 'true');
            }
          });
        }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });
        observer.observe(sentinel);
      }
    }

    // Thumbnail gallery — clicking a thumb swaps the main image.
    // Restores conversion-affecting dead-click pattern (Clarity 2026-05-29..06-01
    // showed 3,730 dead clicks on "Golden Pear angle ▫" thumbs over 4 days).
    var mainImg = root.querySelector('[data-ks-main-image]');
    var mainWrap = root.querySelector('[data-ks-main-wrap]');
    var thumbs = root.querySelectorAll('[data-ks-thumb]');
    if (mainImg && thumbs.length) {
      function activateThumb(thumb) {
        var largeSrc = thumb.getAttribute('data-large-src');
        var alt = thumb.getAttribute('data-alt')
                  || mainImg.getAttribute('data-default-alt')
                  || '';
        if (!largeSrc) return;
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        // Fade-swap if the wrap supports it; otherwise direct swap.
        if (mainWrap) mainWrap.classList.add('is-swapping');
        setTimeout(function () {
          mainImg.setAttribute('src', largeSrc);
          mainImg.setAttribute('alt', alt);
          if (mainWrap) mainWrap.classList.remove('is-swapping');
        }, 80);
        emit('gp_thumb_click', { alt: alt });
      }
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () { activateThumb(thumb); });
        thumb.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            activateThumb(thumb);
          }
        });
      });
    }

    // Funnel analytics for the named CTAs across all sections on the page.
    // Uses data-gp-track attribute. Each clickable element opts in by
    // adding data-gp-track="event_name" — we wire those up globally.
    document.addEventListener('click', function (e) {
      var el = e.target.closest('[data-gp-track]');
      if (!el) return;
      emit(el.getAttribute('data-gp-track'), {
        href: el.getAttribute('href') || null,
        text: (el.textContent || '').trim().slice(0, 80)
      });
    });

    // ATC safety net — document-level delegation as a fallback in case the
    // direct addEventListener bindings above missed an ATC button (e.g.,
    // section re-render via theme editor, Shopify sections-everywhere reload).
    // Prevents the "tapped Add to Cart, nothing happened" dead-click pattern
    // (Clarity 2026-05-29..06-01: 235 dead clicks + 163 quickbacks on Add to Cart).
    // Guarded against double-firing via the data-gp-bound attribute set by the
    // direct bindings above.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.add-to-cart, [data-sticky-atc]');
      if (!btn) return;
      if (btn.dataset.gpDelegationHandled === '1') return;
      // If the direct handlers above are still wired, they'll fire first; this
      // is the safety net for the race-condition / re-mount case.
      if (atcBtn === btn || stickyBtn === btn) {
        // direct handler exists and will run; no-op here
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      btn.dataset.gpDelegationHandled = '1';
      try { submitAdd(btn); } finally { btn.dataset.gpDelegationHandled = ''; }
    });

    function emit(name, props) {
      try {
        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push(Object.assign({ event: name }, props || {}));
        }
        if (window.analytics && typeof window.analytics.track === 'function') {
          window.analytics.track(name, props || {});
        }
        if (window._klOnsite && typeof window._klOnsite.push === 'function') {
          window._klOnsite.push(['track', name, props || {}]);
        }
      } catch (e) { /* swallow */ }
    }

    recalc();
    emit('gp_lp_view', {
      cans_found: parseInt(root.dataset.cansFound || '0', 10),
      drop_size: parseInt(root.dataset.dropSize || '64000', 10)
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
